type CatalogueUrlParams = {
  productId: string | number;
  manufacturerId?: string | number;
  seriesId?: string | number;
  variantId?: string | number;
};

/** Builds `/catalogue` deep-link query string for manufacturer → series → product → variant. */
export function buildCatalogueUrl(params: CatalogueUrlParams): string {
  const search = new URLSearchParams();
  search.set('productId', String(params.productId));
  if (params.manufacturerId != null) search.set('manufacturerId', String(params.manufacturerId));
  if (params.seriesId != null) search.set('seriesId', String(params.seriesId));
  if (params.variantId != null && params.variantId !== '') {
    search.set('variantId', String(params.variantId));
  }
  return `/catalogue?${search.toString()}`;
}
